import Hero from './components/Hero';
import Features from './components/Features';
import RulesPreview from './components/RulesPreview';
import RewardsPreview from './components/RewardsPreview';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '每日大赛Yandex官网',
    url: 'https://yandex-contest.com/',
    description: '每日大赛Yandex官方入口与参赛指南，提供注册流程、参赛规则及奖励说明',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yandex-contest.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '每日大赛Yandex',
    url: 'https://yandex-contest.com/',
    description: 'Yandex旗下官方竞技平台，提供每日在线赛事服务',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '每日大赛Yandex官网入口在哪里？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '每日大赛Yandex官网入口即为本网站首页。您可以直接通过浏览器访问我们的官方网站，在首页即可找到参赛入口。',
        },
      },
      {
        '@type': 'Question',
        name: 'Yandex每日大赛报名需要什么条件？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '报名条件：年满18周岁、拥有有效的Yandex账户、完成实名认证。每天上午10:00开启报名通道，完全免费。',
        },
      },
      {
        '@type': 'Question',
        name: '参赛需要下载什么软件吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yandex每日大赛是纯网页端赛事，无需下载任何软件，使用浏览器访问官方入口即可参赛。',
        },
      },
      {
        '@type': 'Question',
        name: '每日大赛的奖励是怎么计算的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '奖励分为日奖、周奖、月奖和年奖四个层级。日奖根据当日排名即时发放，年度总决赛冠军奖励高达10万元。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <main>
        <Hero />
        <Features />
        <RulesPreview />
        <RewardsPreview />
        <FAQ />
        <CTA />
      </main>
    </>
  );
}